import Translate from "modules/spravochnik/dt-front-page-generator/src/Search/Translate";

export class Utils {
    static like(text: string, query: string): boolean {
        const _query = query.toLowerCase();
        const name = text.toLowerCase();
        return name.includes(_query) || name.includes(Translate.auto(_query));
    }
}
